import { render, staticRenderFns } from "./list.vue?vue&type=template&id=700ed76b&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=700ed76b&prod&scoped=true&lang=css"
import style1 from "./list.vue?vue&type=style&index=1&id=700ed76b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700ed76b",
  null
  
)

export default component.exports